import { CustomCellRendererProps } from "ag-grid-react";
import SupplyPopover from "./SupplyPopover";
import RenewalsDrawer from "./RenewalsDrawer";
import { Button, Icon, Link, Popover, PopoverBody, PopoverContent, PopoverTrigger, Portal, Text, useDisclosure } from "@chakra-ui/react";
import { FaArrowUpRightFromSquare, FaRegCalendar, FaFilePdf  } from "react-icons/fa6";
import SupplyDrawer from "./SupplyDrawer";
import moment from "moment";
import InvoiceDrawer from "./InvoiceDrawer";

function SupplyLinkRenderer(params: CustomCellRendererProps) {
  if (!params.data) return
  const { isOpen, onOpen, onClose } = useDisclosure(); // tracks status of renewals drawer
  // !!! some views have supply_verbose and others have supply_name (supplies vs tickets views)
  const supplyName = params.data.supply_verbose || params.data.supply_name;

  return (
    <>
      <SupplyDrawer id={params.data.supply_id} isOpen={isOpen} onClose={onClose} />
      <SupplyPopover supplyId={params.data.supply_id} supplyName={supplyName} onOpen={onOpen}></SupplyPopover>
    </>  
  );
}

function InvoiceLinkRenderer(params: CustomCellRendererProps) {
  if (!params.data) return
  const { isOpen, onOpen, onClose } = useDisclosure(); // tracks status of invoice drawer
  const invoiceSource = params.data.src?.toUpperCase();
  const isHistoricInvoice = (invoiceSource === "OLD" || invoiceSource === "PDF");

  if (isHistoricInvoice) {
    return (
      <Popover placement='top-start' trigger="hover">
        <PopoverTrigger>
          <Text as="span" fontStyle="italic" cursor="pointer">
            {params.data.invoice_number}
          </Text>
        </PopoverTrigger>
        <Portal>
          <PopoverContent w={350}>
            <PopoverBody>
              Drilldown is not available on this invoice - this is historic data and this invoice has not been parsed to extract all the detailed charge elements. Generally invoices from the start of 2026 will be parsed.
            </PopoverBody>
          </PopoverContent>
        </Portal>
      </Popover>
    );
  }

  return (
    <>
      <InvoiceDrawer invoice={params.data} isOpen={isOpen} onClose={onClose} />
      <Link color='blue.100' onClick={onOpen}>{params.data.invoice_number} <Icon as={FaArrowUpRightFromSquare} fontSize={'xs'} /></Link>
    </>
  );
}

function InvoiceFileButtonRenderer(params: CustomCellRendererProps) {
  if (!params.data) return
  const filehash = params.data.filehash;
  const isDisabled = !filehash;

  if (!filehash) {
    return (
      <>
      </>
    );
  }

  return (
    <Button
      size="xs"
      isDisabled={isDisabled}
      onClick={(event) => {
        event.stopPropagation();
        if (!filehash) return;
        window.open(`/file-viewer/${encodeURIComponent(filehash)}`, "_blank", "noopener,noreferrer");
      }}
    >
      <Icon as={FaFilePdf} />
    </Button>
  );
}

function CEDLinkRenderer(params: CustomCellRendererProps) {
  if (!params.data) return
  const { isOpen, onOpen, onClose } = useDisclosure(); // tracks status of renewals drawer

  const date = (params.data.contract_end_date) ? new Date(params.data.contract_end_date) : null;
  let dateString = getCEDString(date, params.data.rollingcontract);

  return (
    <>
      <RenewalsDrawer isOpen={isOpen} onClose={onClose} ced={date} />
      <Link color='blue.100' onClick={onOpen}><Icon as={FaRegCalendar}/> {(dateString)}</Link>
    </>
  )
}

// function that returns text representation of CED including unknown / out of contract - !!! move this to a util file?
function getCEDString(ced: Date | null, rolling: boolean){
  let dateString;
  if (rolling){
    dateString = "Out of Contract";
  } else {
    dateString = (ced) ? moment(ced).format('DD/MM/YYYY') : "Unknown";
  }
  return dateString;
}

function yesNoRenderer(params: CustomCellRendererProps){
  if (!params.data) return

  if (params.data.eb_isexportmeter)
    return "Yes";
  else
    return "No";
}


export { SupplyLinkRenderer, InvoiceLinkRenderer, InvoiceFileButtonRenderer, CEDLinkRenderer, getCEDString, yesNoRenderer }
